const accountData = {
  banco: 'Santander',
  iban: 'ES22 1234 5678 00 1234567890',
  bic: 'SANXXERFPPO',
  domicilio: 'Severo Ochoa',
  poblacion: 'Madrid',
  provincia: 'Madrid'
};

const bankAccount = {
  bankAccountConfirm: {
    title: 'TU SOLICITUD DE CAMBIO DE DOMICILIACIÓN BANCARIA HA SIDO ENVIADA',
    txt: 'En breve te confirmaremos la actualización de los datos.',
    btn: 'Volver a mis datos'
  },
  bankAccountForm: {
    title: 'Solicitud de cambio de domiciliación bancaria',
    label: 'Nuevo IBAN',
    btn: 'Enviar solicitud'
  },
  bankAccountBreadcrumb: {
    first: 'Mis datos',
    second: 'Solicitar cambio de banco'
  },
  bankAccountPending:
    'Tienes una solicitud de cambio de domiciliación bancaria pendiente de validar',
  bankAccountBtn: 'SOLICITAR CAMBIO DE BANCO',
  bankAccountResume: {
    title: 'DOMICILIO PERSONAL ACTUAL'
  },
  label: {
    banco: 'Banco',
    iban: 'IBAN',
    bic: 'Código BIC',
    domicilio: 'Domicilio',
    poblacion: 'Población',
    provincia: 'Provincia'
  }
};
const dataSectionBankAccount = {
  fake: 'Sin datos'
};

export { accountData, dataSectionBankAccount, bankAccount };
